<template>
  <div class="container">
    <div class="block block-noAny" v-if="noAnyServer">
      <div class="content-inner-wrapper">
        <img class="noAnyImg" src="../../images/mobile/noAny.svg" />
        <p>购买云服和好朋友一起开启游戏吧～</p>
        <van-button
          @click="
            $router.push({ name: 'cloudServerBuy', params: { type: 'new' } })
          "
          >购买云服</van-button
        >
      </div>
    </div>
    <div
      class="block"
      :class="{ expiredDisplay: activeName === 'expired' }"
      v-else
    >
      <div class="content-inner-wrapper">
        <div class="content-header">
          <h3>云服</h3>
          <div class="btnGroup">
            <van-popover
              v-model="showPopover"
              trigger="click"
              :actions="actions"
              @select="onSelect"
            >
              <template #reference>
                <van-button>更多</van-button>
              </template>
            </van-popover>
            <!-- <van-button @click="$router.push({ name: 'cloudServerOrderList' })">购买记录</van-button> -->
            <van-button
              @click="
                $router.push({
                  name: 'cloudServerBuy',
                  params: { type: 'new' },
                })
              "
              >购买云服</van-button
            >
          </div>
        </div>
        <div class="dataPanle" v-show="isDeveloper">
          <div class="dataItem dataItem-ad">
            <h4>本月云服广告播放</h4>
            <p class="currMonth">
              {{ month_ad_count | format10Thousand }}
              <span class="item-wan" v-show="month_ad_count >= UNIT">万</span>
            </p>
            <p class="yestoday">
              昨日 {{ yesterday_ad_count | format10Thousand }}
              <em v-show="yesterday_ad_count >= UNIT">万</em>
            </p>
          </div>
          <div class="dataItem dataItem-minicoin">
            <h4>本月贡献点收入</h4>
            <p class="currMonth">
              {{ month_contribution | format10Thousand(3)
              }}<span class="item-wan" v-show="month_contribution >= UNIT"
                >万</span
              >
            </p>
            <p class="yestoday">
              昨日 {{ yesterday_contribution | format10Thousand(3) }}
              <em v-show="yesterday_contribution >= UNIT">万</em>
            </p>
          </div>
          <div class="dataItem dataItem-game">
            <h4>本月游戏</h4>
            <p class="currMonth">
              {{ month_player_count | format10Thousand
              }}<span class="item-wan" v-show="month_player_count >= UNIT"
                >万</span
              >
            </p>
            <p class="yestoday">
              昨日 {{ yesterday_player_count | format10Thousand }}
              <em v-show="yesterday_player_count >= UNIT">万</em>
            </p>
          </div>
          <div class="dataItem dataItem-map">
            <h4>本月游戏时长(分)</h4>
            <p class="currMonth">
              {{ month_total_time | format10Thousand
              }}<span class="item-wan" v-show="month_total_time >= UNIT"
                >万</span
              >
            </p>
            <p class="yestoday">
              昨日 {{ yesterday_total_time | format10Thousand }}
              <em v-show="yesterday_total_time >= UNIT">万</em>
            </p>
          </div>
        </div>
        <van-tabs v-model="activeName" @change="handleTabsClick">
          <van-field
            v-model="searchText"
            center
            label="   "
            placeholder="输入关键字搜索"
            @input="debounceSearch"
            v-show="!bacthSelected"
          >
            <template #button>
              <Selector
                :selectArr="searchArr"
                @change="selectChange"
                :displayLabel="false"
                :currVal="parseInt(currSelectVal, 10)"
              >
              </Selector>
            </template>
          </van-field>
          <van-tab :title="'全部(' + allCount + ')'" name="1">
            <div class="cloudServWrap">
              <van-checkbox-group
                v-model="multipleSelectionAll"
                ref="multipleTableAll"
                @change="handleAllSelectionChange"
              >
                <div
                  class="cloudServItem"
                  :class="{ expired: item.expired }"
                  v-for="(item, index) in allData"
                  :key="item.id + '' + index"
                >
                  <van-checkbox
                    :name="item"
                    ref="checkboxes"
                    shape="square"
                    v-show="bacthSelected"
                  />
                  <img
                    :src="item.image | setDefaultMapImg"
                    @click="
                      $router.push({
                        name: 'cloudServerData',
                        params: { currServ: JSON.stringify(item) },
                      })
                    "
                  />
                  <div
                    class="servInfo"
                    @click="
                      $router.push({
                        name: 'cloudServerData',
                        params: { currServ: JSON.stringify(item) },
                      })
                    "
                  >
                    <h3>{{ item.room_name }}</h3>
                    <p>云服ID：{{ item.id }}</p>
                    <p>({{ ROOM_TYPE[item.room_type] }})</p>
                    <p :class="{ 'warn-time': isWarnDay(item.expire_time) }">
                      剩余{{ item.expire_time | remainderTime }}
                    </p>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
            <van-pagination
              v-model="pagination.page"
              @change="allDataPageChange"
              :force-ellipses="true"
              :total-items="pagination.total"
              :show-page-size="4"
            >
              <template #prev-text>
                <van-icon name="arrow-left" />
              </template>
              <template #next-text>
                <van-icon name="arrow" />
              </template>
              <template #page="{ text }">{{ text }}</template>
            </van-pagination>
            <transition name="fade">
              <div class="batchRenew" v-show="bacthSelected">
                <van-checkbox
                  :value="selectAllAll"
                  @click="batchSelectChangeAll"
                  shape="square"
                  >全选</van-checkbox
                >
                <div class="btnWrap">
                  <van-button @click="cancelSelectAll" class="batchCancelBtn"
                    >取消</van-button
                  >
                  <van-button
                    type="primary"
                    class="batchRenewBtn"
                    @click="batchRenew('all')"
                    >批量续费</van-button
                  >
                </div>
              </div>
            </transition>
          </van-tab>
          <van-tab :title="`生效中(${validCount})`" name="2">
            <div class="cloudServWrap">
              <van-checkbox-group
                v-model="multipleSelectionUsing"
                ref="multipleTableUsing"
                @change="handleUsingSelectionChange"
              >
                <div
                  class="cloudServItem"
                  :class="{ expired: item.expired }"
                  v-for="(item, index) in serversUsing"
                  :key="item.id + '' + index"
                >
                  <van-checkbox
                    :name="item"
                    ref="checkboxes"
                    shape="square"
                    v-show="bacthSelected"
                  />
                  <img
                    :src="item.image | setDefaultMapImg"
                    @click="
                      $router.push({
                        name: 'cloudServerData',
                        params: { currServ: JSON.stringify(item) },
                      })
                    "
                  />
                  <div
                    class="servInfo"
                    @click="
                      $router.push({
                        name: 'cloudServerData',
                        params: { currServ: JSON.stringify(item) },
                      })
                    "
                  >
                    <h3>{{ item.room_name }}</h3>
                    <p>云服ID：{{ item.id }}</p>
                    <p>({{ ROOM_TYPE[item.room_type] }})</p>
                    <p :class="{ 'warn-time': isWarnDay(item.expire_time) }">
                      剩余{{ item.expire_time | remainderTime }}
                    </p>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
            <van-pagination
              v-model="usingPagination.page"
              :force-ellipses="true"
              @change="usingDataPageChange"
              :total-items="usingPagination.total"
              :show-page-size="5"
            >
              <template #prev-text>
                <van-icon name="arrow-left" />
              </template>
              <template #next-text>
                <van-icon name="arrow" />
              </template>
              <template #page="{ text }">{{ text }}</template>
            </van-pagination>
            <transition name="fade">
              <div class="batchRenew" v-show="bacthSelected">
                <van-checkbox
                  :value="selectAllUsing"
                  @click="batchSelectChangeUsing"
                  shape="square"
                  >全选</van-checkbox
                >
                <div class="btnWrap">
                  <van-button @click="cancelSelectUsing" class="batchCancelBtn"
                    >取消</van-button
                  >
                  <van-button
                    type="primary"
                    class="batchRenewBtn"
                    @click="batchRenew('using')"
                    >批量续费</van-button
                  >
                </div>
              </div>
            </transition>
          </van-tab>
          <van-tab
            class="van-tab-expired"
            :title="`已过期(${unvalidCount})`"
            name="3"
          >
            <div class="cloudServWrap">
              <van-checkbox-group
                v-model="multipleSelectionExpired"
                ref="multipleTableExpired"
                @change="handleExpiredSelectionChange"
              >
                <div
                  class="cloudServItem"
                  :class="{ expired: item.expired }"
                  v-for="(item, index) in serversExpired"
                  :key="item.id + '' + index"
                >
                  <van-checkbox
                    :name="item"
                    ref="checkboxes"
                    shape="square"
                    v-show="bacthSelected"
                  />
                  <img
                    :src="item.image | setDefaultMapImg"
                    @click="
                      $router.push({
                        name: 'cloudServerData',
                        params: { currServ: JSON.stringify(item) },
                      })
                    "
                  />
                  <div
                    class="servInfo"
                    @click="
                      $router.push({
                        name: 'cloudServerData',
                        params: { currServ: JSON.stringify(item) },
                      })
                    "
                  >
                    <h3>{{ item.room_name }}</h3>
                    <p>云服ID：{{ item.id }}</p>
                    <p>({{ ROOM_TYPE[item.room_type] }})</p>
                    <p :class="{ 'warn-time': isWarnDay(item.expire_time) }">
                      剩余{{ item.expire_time | remainderTime }}
                    </p>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
            <van-pagination
              v-model="expiredPagination.page"
              :force-ellipses="true"
              @change="expiredDataPageChange"
              :total-items="expiredPagination.total"
              :show-page-size="5"
            >
              <template #prev-text>
                <van-icon name="arrow-left" />
              </template>
              <template #next-text>
                <van-icon name="arrow" />
              </template>
              <template #page="{ text }">{{ text }}</template>
            </van-pagination>
            <transition name="fade">
              <div class="batchRenew" v-show="bacthSelected">
                <van-checkbox
                  :value="selectAllExpired"
                  @click="batchSelectChangeExpired"
                  shape="square"
                  >全选</van-checkbox
                >
                <div class="btnWrap">
                  <van-button
                    @click="cancelSelectExpired"
                    class="batchCancelBtn"
                    >取消</van-button
                  >
                  <van-button
                    type="primary"
                    class="batchRenewBtn"
                    @click="batchRenew('expired')"
                    >批量续费</van-button
                  >
                </div>
              </div>
            </transition>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Selector from '../../components/m/Selector.vue';
import mixins from '../../mixins/manager.mixins.js';
export default {
  components: {
    Selector,
  },
  mixins: [mixins],
  data() {
    return {
      actions: [
        { text: '购买记录', type: 'record' },
        { text: '批量管理', type: 'batchManager', icon: '' },
      ],
      bacthSelected: false,
      showPopover: false,
      searchText: '',
      currentPage: 0,
      multipleSelectionAll: [],
      multipleSelectionUsing: [],
      multipleSelectionExpired: [],
      currSelectVal: 1,
      searchArr: [
        { name: '默认', value: 1 },
        { name: '最近到期', value: 2 },
        { name: '开启时间', value: 3 },
      ],
      //
    };
  },
  mounted() {
    this.cloudShow();
  },
  watch: {
    bacthSelected: function (newval) {
      this.actions[1].icon = newval ? 'success' : '';
    },
  },
  methods: {
    //云服管理曝光埋点
    cloudShow() {
      this.$log('cloudservice_management_show', 85436, { v7: 2 });
    },
    onSelect(action) {
      console.log('onSelect----', action);
      switch (action.type) {
        case 'record':
          this.$router.push({ name: 'cloudServerOrderList' });
          break;
        case 'batchManager':
          this.bacthSelected = !this.bacthSelected;
          break;
      }
    },
    cancelSelectAll() {
      this.bacthSelected = false;
      this.$refs.multipleTableAll.toggleAll(false);
    },
    cancelSelectUsing() {
      this.bacthSelected = false;
      this.$refs.multipleTableUsing.toggleAll(false);
    },
    cancelSelectExpired() {
      this.bacthSelected = false;
      this.$refs.multipleTableExpired.toggleAll(false);
    },
    batchSelectChangeAll() {
      if (this.selectAllAll) {
        this.$refs.multipleTableAll.toggleAll(false);
      } else {
        this.$refs.multipleTableAll.toggleAll(true);
      }
    },
    batchSelectChangeUsing() {
      if (this.selectUsingAll) {
        this.$refs.multipleTableUsing.toggleAll(false);
      } else {
        this.$refs.multipleTableUsing.toggleAll(true);
      }
    },
    batchSelectChangeExpired() {
      if (this.selectAllExpired) {
        this.$refs.multipleTableExpired.toggleAll(false);
      } else {
        this.$refs.multipleTableExpired.toggleAll(true);
      }
    },
    handleTabsClick(name) {
      console.log('handleTabsClick---', name);
    },
    selectChange(val) {
      console.log('selectChange', val);
      this.sortType = val.value + '';
      this.changeSortType();
    },
  },
};
</script>
<style src="../../style/common-m.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.block.expiredDisplay {
  margin-bottom: 108px;
}
.block.block-noAny {
  .content-inner-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .noAnyImg {
    display: block;
    width: 480px;
    height: 350px;
    margin-top: 260px;
  }
  p {
    width: 100%;
    height: 34px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 34px;
    margin: 32px auto 108px;
    text-align: center;
  }
  .van-button {
    width: 526px;
    height: 84px;
    background: #fd9b21ff;
    border-radius: 16px;
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    line-height: 40px;
    margin-bottom: 278px;
  }
}
.content-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .btnGroup {
    .van-button {
      margin-right: 0;
      margin-left: 16px;
      width: auto;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fd9b21;
      line-height: 34px;
      padding: 10px 32px 12px;
    }
  }
}
.dataPanle {
  width: 646px;
  height: auto;
  overflow: visible;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 30px;
  .dataItem {
    position: relative;
    width: 313px;
    height: 212px;
    margin-right: 20px;
    margin-bottom: 20px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.3);
    border-radius: 12px;
    padding-left: 32px;
    background: #b394ff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &:nth-child(2n) {
      margin-right: 0;
    }
    h4 {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
      line-height: 34px;
    }
    p {
      position: relative;
      z-index: 9;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .currMonth {
      font-size: 44px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 60px;
      margin: 12px 0 8px;
    }
    .yestoday {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 34px;
    }
    &.dataItem-minicoin {
      background-color: #ffc95c;
      &::after {
        background-image: url('../../images/common/br_icon_minicoin.svg');
      }
    }
    &.dataItem-game {
      background-color: #6bc1ff;
      &::after {
        background-image: url('../../images/common/br_icon_game.svg');
      }
    }
    &.dataItem-map {
      background-color: #42db99;
      &::after {
        background-image: url('../../images/common/br_icon_map.svg');
      }
    }
    &::after {
      display: block;
      content: '';
      width: 100px;
      height: 100px;
      position: absolute;
      right: 0;
      bottom: 0;
      background: url('../../images/common/br_icon_ad.svg') 0 0 no-repeat;
      background-size: 100px;
    }
  }
}
.van-tabs {
  ::v-deep .van-tabs__wrap {
    height: auto;
    overflow: hidden;
    .van-tabs__nav {
      justify-content: flex-start;
      padding-bottom: 32px;
      border-bottom: 2px solid #d9d9d9;
      .van-tab {
        flex: unset;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #595959;
        line-height: 40px;
        margin-right: 48px;
        padding-top: 114px;
        &.van-tab--active {
          color: #fd9b21;
        }
      }
      .van-tabs__line {
        background-color: #fd9b21;
        width: 80px;
        bottom: 0;
      }
    }
  }
  ::v-deep .van-tabs__content {
    .van-tab__pane {
      margin-top: 20px;
    }
  }
  .van-field {
    border-bottom: none;
    overflow: visible;
    padding-right: 0;
    padding-left: 0;
    &::after {
      display: none;
    }
    ::v-deep .van-field__body {
      justify-content: space-between;
      .ul-box {
        right: 2px;
      }
    }
    ::v-deep .van-field__value {
      input[type='text'] {
        width: 292px;
        height: 68px;
        border: 2px solid #ccc;
        border-radius: 8px;
        font-size: 28px;
        line-height: 40px;
        padding: 0 24px;
      }
    }
    ::v-deep .select-day .select-wrap input {
      width: 166px;
      height: 68px;
      border-radius: 16px;
      border: 2px solid #ccc;
      font-size: 24px;
      line-height: 34px;
      color: #262626;
    }
  }
}
.cloudServItem {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
  .van-checkbox {
    margin-right: 16px;
    flex: 0 0 auto;
    ::v-deep .van-icon {
      width: 24px;
      height: 24px;
      font-size: 16px;
      line-height: 1;
    }
  }
  img {
    width: 284px;
    height: 160px;
    background: #f2f2f2;
    border-radius: 11px;
    margin-right: 16px;
  }
  &.expired {
    img {
      filter: grayscale(1);
    }
    .warn-time {
      color: #f73535;
    }
  }
  .servInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    h3 {
      height: 34px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 34px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 380px;
    }
    p {
      height: 34px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #878d99;
      line-height: 34px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 8px;
    }
  }
}
.batchRenew {
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0 44px;
  width: 100%;
  height: 88px;
  background: #ffffff;
  box-shadow: 0px -2px 14px 2px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 998;
  .van-checkbox {
    height: 40px;
    ::v-deep .van-checkbox__icon {
      height: auto;
    }
    ::v-deep .van-checkbox__label {
      margin-left: 16px;
    }
    ::v-deep .van-icon {
      width: 24px;
      height: 24px;
      font-size: 16px;
      line-height: 1;
    }
  }
  .batchCancelBtn {
    width: 160px;
    height: 56px;
    border-radius: 12px;
    border: 2px solid #8c8c8c;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 34px;
  }
  .batchRenewBtn {
    margin-left: 24px;
    width: 160px;
    height: 56px;
    background: #fecb4e;
    border-radius: 12px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3d3c3c;
    line-height: 34px;
    border-color: #fecb4e;
    white-space: nowrap;
  }
}
</style>
